"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTablePreloaderBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var BcDataTablePreloaderBehavior = (function () {
    function BcDataTablePreloaderBehavior(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.preloaderTableId = this.getPreloaderTableId();
    }
    BcDataTablePreloaderBehavior.prototype.getPreloaderTableId = function () {
        return this.bcDataTableConfig.id + bc_data_table_constants_1.BcDataTableConstansts.ATTR_TABINDEX_NEGATIVE + bc_data_table_constants_1.BcDataTableConstansts.PRELOADER;
    };
    BcDataTablePreloaderBehavior.prototype.init = function (dataTable) {
        var parentElement = dataTable.parentElement;
        var preloaderTable = this.createPreloaderTable(dataTable);
        this.addPreloaderTableRows(preloaderTable);
        parentElement.append(preloaderTable);
        return this.preloaderTableId;
    };
    BcDataTablePreloaderBehavior.prototype.addPreloaderTableRows = function (dataTable) {
        var preloaderTableRows = this.bcDataTableConfig.preloader.rows;
        for (var index = 0; index < preloaderTableRows; index++) {
            var trElement = document.createElement(common_constants_1.BcCommonConstants.TR_TAG);
            var preloaderTableRow = this.addPreloaderTableColumns(trElement);
            dataTable.tBodies[0].appendChild(preloaderTableRow);
        }
    };
    BcDataTablePreloaderBehavior.prototype.addPreloaderTableColumns = function (preloaderTableRow) {
        var preloaderTableColumns = this.bcDataTableConfig.preloader.columns;
        for (var index = 0; index < preloaderTableColumns; index++) {
            var tdElement = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
            var preloaderTableColumn = this.createPreloaderElement(tdElement);
            preloaderTableRow.appendChild(preloaderTableColumn);
        }
        return preloaderTableRow;
    };
    BcDataTablePreloaderBehavior.prototype.createPreloaderElement = function (tdElement) {
        var divContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.PRELOADER_CLASS);
        divContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.PRELOADER_CLASS_LINE);
        tdElement.append(divContainer);
        return tdElement;
    };
    BcDataTablePreloaderBehavior.prototype.createPreloaderTable = function (dataTable) {
        var preloaderTable = document.createElement(common_constants_1.BcCommonConstants.TABLE_TAG);
        preloaderTable.createTBody();
        preloaderTable.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_CLASS);
        preloaderTable.setAttribute(common_constants_1.BcCommonConstants.ID, this.preloaderTableId);
        return preloaderTable;
    };
    return BcDataTablePreloaderBehavior;
}());
exports.BcDataTablePreloaderBehavior = BcDataTablePreloaderBehavior;
